<script>
  import router from '../../lib/router';
  import { onMount } from 'svelte';
  import session from '../../lib/session';
  import Dialog from '../../lib/components/Dialog.svelte';
  import APIClient from '../../state-charts/api-client';
  import { TS } from '../../config/translation-keys.js';
  import { t9n } from '../../lib/translate.js';

  // component options  ------------------------------------------------------ //

  export let profile;
  export let is_applicant = false;
  export let order_uuid;
  export let query;
  let is_opp = false;

  let show_age_range = false;
  let only_for_worker_text = t9n(TS.PROFILE_ONLY_FOR_WORKER_TEXT);
  let profile_available_after_worker_selected = t9n(TS.PROFILE_AVAIL_AFTER_WORKER_SELECTED)

  let is_hidden = false;
  let applicant_contact_details_hidden = false;
  let applicant_selected = false;

  const init_profile = () => {
    if (
      profile._user &&
      profile._user.order &&
      profile._user.order.applications &&
      profile._user.order.applications.length > 0
    ) {
      profile._user.order.applications.map(a => {
        if (a.worker.basic_profile.id === profile._user.id) {
          is_hidden = a.hidden;
        }
      });
    }
    let url_string = window.location.href;
    let url = new URL(url_string);
    is_opp = url.searchParams.get('opp') === 'true';
    show_age_range = get_show_age_range();
    applicant_contact_details_hidden = $session.merchant.applicant_contact_details_hidden;
    // applicant_contact_details_hidden = true;
    // applicant_selected = order.worker
  };

  const select_applicant = make_a_copy => {
    router.navigate(
      `/order-details?id=${order_uuid}&select_applicant=true&make_a_copy=${make_a_copy}&worker_id=${profile.user.id}`
    );
  };

  const get_worker_info = () => {
    if (is_applicant) {
      for (let i = 0; i < profile._user.order.applications.length; i++) {
        if (
          profile._user.order.applications[i].worker.basic_profile.id ===
          profile.user.id
        ) {
          return profile._user.order.applications[i].message;
        }
      }
    }
  };

  const get_cv_visible = () => {
    if (is_applicant && profile._role === 'worker') {
      return profile._user.cv_is_public
    }
  }

  const get_product_tags = () => {
    const lang_key = `translation_${$session.language}`;

    return $session.merchant.product_tags.map(t => t.localized_names[lang_key]);
  };

  const hide_user = async () => {
    await APIClient.hide_application(
      {
        order_uuid: order_uuid,
        worker_id: profile._user.id,
      },
      () => {
        location.reload();
      }
    );
  };

  const unhide_user = async () => {
    await APIClient.show_application(
      {
        order_uuid: order_uuid,
        worker_id: profile._user.id,
      },
      () => {
        location.reload();
      }
    );
  };

  const create_hide_dialog = () => {
    let target = document.querySelector('.hide-dialog');
    target.innerHTML = '';

    let dialog = new Dialog({
      target: target,
      props: {
        id: 'header-message',
        title: t9n(TS.ORDER_HIDE_USER),
        content: t9n(TS.ORDER_HIDE_USER_CONTENT),
        buttons: [
          {
            label: t9n(TS.TXT_CANCEL),
            action: () => {
              dialog.close();
            },
            classes: [],
          },
          {
            label: t9n(TS.TXT_YES),
            action: async () => {
              dialog.close();
              await hide_user();
            },
            classes: [],
          },
        ],
      },
    });

    return dialog;
  };

  let toggle_hide_dialog = () => {
    let dialog = create_hide_dialog();
    dialog.open();
  };

  const create_unhide_dialog = () => {
    let target = document.querySelector('.hide-dialog');
    target.innerHTML = '';

    let dialog = new Dialog({
      target: target,
      props: {
        id: 'header2-message',
        title: t9n(TS.ORDER_UNHIDE_USER),
        content: t9n(TS.ORDER_UNHIDE_USER_CONTENT),
        buttons: [
          {
            label: t9n(TS.TXT_CANCEL),
            action: () => {
              dialog.close();
            },
            classes: [],
          },
          {
            label: t9n(TS.TXT_YES),
            action: async () => {
              dialog.close();
              await unhide_user();
            },
            classes: [],
          },
        ],
      },
    });

    return dialog;
  };

  let toggle_unhide_dialog = () => {
    let dialog = create_unhide_dialog();
    dialog.open();
  };

  const create_select_dialog = () => {
    let target = document.querySelector('.select-dialog');
    target.innerHTML = '';

    let dialog = new Dialog({
      target: target,
      props: {
        id: 'header3-message',
        title: t9n(TS.ORDER_SELECT_APPL),
        content: t9n(TS.ORDER_MORE_APPL),
        buttons: [
          {
            label: t9n(TS.TXT_CANCEL),
            action: () => {
              dialog.close();
            },
            classes: [],
          },
          {
            label: t9n(TS.TXT_YES),
            action: () => {
              select_applicant(true);
              dialog.close();
            },
            classes: [],
          },
          {
            label: t9n(TS.ORDER_NO_ONLY_ONE),
            action: () => {
              select_applicant(false);
              dialog.close();
            },
            classes: [],
          },
        ],
      },
    });

    return dialog;
  };

  const select_worker = () => {
    let dialog = create_select_dialog();
    dialog.open();
  };

  const back_to_order = () => {
    router.navigate(`/order-details?id=${order_uuid}`);
  };

  const only_for_worker = info => {
    let public_info = only_for_worker_text;

    if (is_opp === false) {
      public_info = info;
      // if (profile._user && profile._user.order && profile._user.order.worker.basic_profile.user_id === profile.user_id) {
      //
      // }
    }

    return public_info;
  };

  const get_show_age_range = () => {
    return $session.merchant.show_age_range;
  }

  onMount(init_profile);
</script>

<!--<div class="mdc-card detail-section fade-in">-->
<div class="detail-section mdc-card roll-out">
  <!--<div class="detail-section mdc-card roll-in delay1">-->
  <table
    id="public-profile-info"
    class="mdc-data-table__table table transparent fitscreen order-table">
    <tbody class="mdc-data-table__content">

      {#if is_applicant}
        <tr class="phone-number mdc-data-table__row">
          <td>
            <b class="pull-right">{profile.worker_info_label}</b>
          </td>
          <td class="content cell-right">
            {#if !!get_worker_info()}{get_worker_info()}{/if}
          </td>
        </tr>
      {/if}

      <tr class="description mdc-data-table__row">
        <td>
          <b class="pull-right">{profile.description_label}</b>
        </td>
        <td class="content cell-right" style="position:relative; white-space: pre-line">
          {#if !!profile.description}{profile.description}{/if}

        </td>
      </tr>

      {#if profile._role === 'worker' && !!profile._user.age_range && show_age_range && profile._user.age_range !== "age_range_null"}
        <tr class="phone-number mdc-data-table__row">
          <td>
            <b class="pull-right">{t9n(TS.APPLICANT_AGE_RANGE)}</b>
          </td>
          <td class="content cell-right">
            {t9n(profile._user.age_range)}
          </td>
        </tr>
      {/if}

      <!--{#if profile._role === 'worker' && !!profile._user.worker_type}-->
      <!--  <tr class="phone-number mdc-data-table__row">-->
      <!--    <td>-->
      <!--      <b class="pull-right">{t9n(TS.SETTINGS_LABEL_WORKER_TYPE)}</b>-->
      <!--    </td>-->
      <!--    <td class="content cell-right">-->
      <!--      {t9n(profile._user.worker_type)}-->
      <!--    </td>-->
      <!--  </tr>-->
      <!--{/if}-->

      <tr class="city mdc-data-table__row">
        <td>
          <b class="pull-right">{profile.city_label}</b>
        </td>
        <td class="content cell-right">
          {#if !!profile.city}{profile.city}{/if}

        </td>
      </tr>

      <tr class="postal-code mdc-data-table__row">
        <td>
          <b class="pull-right ">{profile.postal_code_label}</b>
        </td>
        <td class="content cell-right ">
          {#if !!profile.postal_code}{profile.postal_code}{/if}

        </td>
      </tr>

      <tr class="phone-number mdc-data-table__row">
        <td>
          <b class="pull-right">{profile.phone_number_label}</b>
        </td>
        <td class="content cell-right">
          {#if applicant_contact_details_hidden}
            {profile_available_after_worker_selected}
          {:else}
            {#if !!profile.phone_number}
              {#if !is_opp}
                {only_for_worker(profile.phone_number)}
              {:else}{only_for_worker_text}{/if}
            {/if}
          {/if}

        </td>
      </tr>

      <tr class="email mdc-data-table__row">
        <td>
          <b class="pull-right ">{profile.email_label}</b>
        </td>
        <td class="content cell-right">
          {#if applicant_contact_details_hidden}
            {profile_available_after_worker_selected}
          {:else}
            {#if !!profile.email}
              {#if !is_opp}
                {only_for_worker(profile.email)}
              {:else}{only_for_worker_text}{/if}
            {/if}
          {/if}
        </td>
      </tr>

      {#if is_applicant && ['worker_type_company', 'worker_type_other'].includes(profile.worker_type)}
        <tr class="email mdc-data-table__row">
          <td>
            <b class="pull-right ">{profile.company_info_label}</b>
          </td>
          <td class="content cell-right">
            {profile.company_info}
            <br />
            {profile.company_number}
          </td>
        </tr>
      {/if}

      {#if (profile.role === 'worker' && !is_opp) || (is_applicant && get_cv_visible())}
        <tr class="cv-link mdc-data-table__row">
          <td>
            <b class="pull-right">{profile.cv_label}</b>
          </td>
          <td class="content cell-right">
            <a href={profile.cv_url} target="_blank">{profile.cv_link_text}</a>
          </td>
        </tr>
      {/if}

      <!--{#if is_applicant}-->
      <!--{#if ('linkedin_link_text') in profile}-->
      {#if (profile.role === 'worker' && !is_opp)}
        <tr class="cv-link mdc-data-table__row">
          <td>
            <b class="pull-right">{profile.linkedin_label}</b>
          </td>
          <td class="content cell-right">
            <a href={profile.linkedin_url} target="_blank">
              {profile.linkedin_link_text}
            </a>
          </td>
        </tr>
          {#if (!!profile.referee)}
            <tr class="cv-link mdc-data-table__row">
              <td>
                <b class="pull-right">{profile.referee_label}</b>
              </td>
              <td class="content cell-right">
                {profile.referee_text}
              </td>
            </tr>
          {/if}
      {/if}
    </tbody>
  </table>

  {#if is_applicant}
    <div style="text-align: center">
      {#if is_hidden}
        <button
          style="margin-top: 15px;"
          title="Select"
          on:click={() => toggle_unhide_dialog()}
          class="mdc-button mdc-button--unelevated margin-5">
          <span class="mdc-button__ripple" />
          {t9n(TS.ORDER_UNHIDE_USER)}
        </button>
      {:else}
        <button
          style="margin-top: 15px;"
          title="Select"
          on:click={() => toggle_hide_dialog()}
          class="mdc-button mdc-button--unelevated margin-5">
          <span class="mdc-button__ripple" />
          {t9n(TS.ORDER_HIDE_USER)}
        </button>
      {/if}

      <button
        style="margin-top: 15px;"
        title="Select"
        on:click={() => select_worker()}
        class="mdc-button mdc-button--unelevated margin-5">
        <span class="mdc-button__ripple" />
        {t9n(TS.TXT_SELECT)}
      </button>

      <button
        style="margin-top: 15px;"
        title="Back"
        on:click={() => back_to_order()}
        class="mdc-button mdc-button--unelevated margin-5">
        <span class="mdc-button__ripple" />
        {t9n(TS.TXT_BACK)}
      </button>
    </div>
  {/if}
</div>

<div class="hide-dialog" />

<style>
  body {
    font-family: Roboto, sans-serif;
    color: #7a7676;
    line-height: 20px;
    font-size: 16px;
  }

  th {
    font-weight: 800;
    color: #616161;
  }

  td {
    font-weight: 500;
    color: #616161;
  }

  .mdc-data-table__row {
    border-top-style: dashed;
  }

  table.fitscreen {
    table-layout: fixed;
  }

  .table {
    color: #333;
    width: 100%;
    border: 0;
    border-radius: 0;
    overflow-x: auto;
    /*margin-bottom: 10px;*/
  }

  .table thead > tr > th,
  .table tbody > tr > th,
  .table tfoot > tr > th,
  .table thead > tr > td,
  .table tbody > tr > td,
  .table tfoot > tr > td {
    padding: 10px;
  }

  /*.order-table.table tbody > tr:first-child td {*/
  /*  padding-top: 30px;*/
  /*}*/

  /*.order-table.table tbody > tr:last-child td {*/
  /*  padding-bottom: 30px;*/
  /*}*/

  .order-table.table tbody > tr > td {
    border: 0;
  }

  .order-table.table tbody > tr > td:first-child {
    width: 20%;
    text-align: right;
  }

  .pull-right {
    float: right !important;
  }

  .order-table.table tbody > tr > td:first-child {
    width: 20%;
    text-align: right;
  }

  /*.order-table.table tbody > tr:first-child td {*/
  /*  padding-top: 30px;*/
  /*}*/

  /*.order-table.table tbody > tr:last-child td {*/
  /*  padding-bottom: 30px;*/
  /*}*/

  .order-table.table tbody > tr > td {
    border: 0;
  }

  .content {
    display: flex;
  }

  .detail-section {
    margin-top: 8px;
    padding: 24px;
  }

  .content .mdc-button {
    position: absolute;
    right: -70px;
    top: 1.5px;
  }

  .cell-right {
    max-width: 680px;
    word-wrap: break-word;
    white-space: normal;
  }

  /* Mobile Mode
  *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
      .email {
          word-break: break-all
      }
  }
</style>
